<template>
    <div class="backgroud-white">
        <div class="text-center">
            <h4>保分项目</h4>
        </div>
        <div class="backgroud-gray-popup popup-content-area-small">
            <el-form ref="model" :rules="rules" :model="model" label-width="100px">
              <div class="cs-englishEnsureScoreEditor-top">
                <span class="cs-englishEnsureScoreEditor-title">单项保分</span>
                <el-form-item label="听力" prop="Listening">
                    <el-input @change='checkAllInputs' placeholder="请输入听力" v-model="model.Listening" class="input-width"></el-input>
                </el-form-item>
                   <el-form-item label="口语" prop="Speaking">
                    <el-input @change='checkAllInputs' placeholder="请输入听力" v-model="model.Speaking" class="input-width"></el-input>
                </el-form-item>
                   <el-form-item label="阅读" prop="Reading">
                    <el-input @change='checkAllInputs' placeholder="请输入听力" v-model="model.Reading" class="input-width"></el-input>
                </el-form-item>
                   <el-form-item label="写作" prop="Writing">
                    <el-input @change='checkAllInputs' placeholder="请输入听力" v-model="model.Writing" class="input-width"></el-input>
                </el-form-item>
                </div>
                <div class="cs-englishEnsureScoreEditor-bottom">
                  <span class="cs-englishEnsureScoreEditor-title">总分保分</span>
                  <el-form-item label="总分" prop="Overall">
                      <el-input @change='checkAllInputs' placeholder="请输入听力" v-model="model.Overall" class="input-width"></el-input>
                  </el-form-item>
                </div>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer popup-footer">
            <el-row>
                <el-col class="footer-right" :span="24">
                    <el-button :disabled="submitBtnDisable" :type="submitBtnClass" @click="save()">保存</el-button>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-englishEnsureScoreEditor-bottom,
.cs-englishEnsureScoreEditor-top{
  .cs-englishEnsureScoreEditor-title{
    display: block;
    width: 100%;
  }
}
.cs-englishEnsureScoreEditor-bottom{
  margin-top: 20px;
}
</style>

<script>
import {
  getEnglishEnsureScore,
  saveEnglishEnsureScore
} from "../../../service/enrollmentFee.service";

export default {
  props: {
    dataIn: {
      Id:Number,
      Overall:String | Number,
      Listening:String | Number,
      Speaking:String | Number,
      Reading:String | Number,
      Writing:String | Number,
      WorkflowId:Number
    }
  },
  data() {
    let validateValue = function(rule, value, callback){
      if (!value){
         callback();
      }

      let message = "";
      let pattern = /^\d+(\.\d+)?$/g;
      let isValid = pattern.test(value);
      if (!!value && !isValid) {
        message = "请输入数字";
      }

      if (Number(value) < 0) {
        message = "请输入大于0的数字";
      }

      if (!!message) {
        callback(new Error(message));
      } else {
        callback();
      }
    };

    return {
      model: {
        Id:0,
        Overall:"",
        Listening:"",
        Speaking:"",
        Reading:"",
        Writing:"",
        WorkflowId:0
      },
      submitBtnClass: "primary",
      submitBtnDisable: false,
      rules: {
        Overall: [
          {
            validator: validateValue,
            trigger: "blur"
          }
        ],
         Listening: [
          {
            validator: validateValue,
            trigger: "blur"
          }
        ],
         Speaking: [
          {
            validator: validateValue,
            trigger: "blur"
          }
        ],
         Reading: [
          {
            validator: validateValue,
            trigger: "blur"
          }
        ],
         Writing: [
          {
            validator: validateValue,
            trigger: "blur"
          }
        ],
      }
    };
  },
  components: {
  },
  created() {
    this.init();
  },
  methods: {
    checkAllInputs() {
      let isValid = true;

      if (!this.$refs["model"]) return false;

      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    save() {
        let isValid = this.checkAllInputs();
        if (!isValid) return false;

        this.submitBtnDisable = true;
        let result = saveEnglishEnsureScore(
          this.model
        ).then(result => {
          if (!result.success) {
            this.errorMessage = result.message;
            this.showError = true;
          } else {
            this.$message({
              message: "保存成功",
              type: "success"
            });
            this.model.Id = result.data;
            this.showError = false;
            this.$emit("saveSuccess", this.model);
            this.close();
          }
          this.submitBtnDisable = false;
        }).catch(()=>{
          this.submitBtnDisable = false;
        });

    },
    close() {
      this.$emit("closeDialog");
    },
    init() {
      this.submitBtnDisable = false;
 
      if (!!this.dataIn) {
        this.model.Id=this.dataIn.Id;
        this.model.Overall=this.dataIn.Overall;
        this.model.Listening=this.dataIn.Listening;
        this.model.Speaking=this.dataIn.Speaking;
        this.model.Reading=this.dataIn.Reading;
        this.model.Writing=this.dataIn.Writing;
        this.model.WorkflowId=this.dataIn.WorkflowId;
      } else {
        this.model.Id=0;
        this.model.Overall="";
        this.model.Listening="";
        this.model.Speaking="";
        this.model.Reading="";
        this.model.Writing="";
        this.model.WorkflowId=0;
      }
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/courseEnrollmentFee/englishEnsureScoreEditor.vue